const cardStyle = {
  card: {
    border: "0",
    marginBottom: "20px",
    marginTop: "0",
    borderRadius: "8px",
    color: "#1a202c",
    background: "#ffffff",
    boxShadow: "0 14px 34px rgba(15,23,42,0.06)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    backgroundClip: "border-box",
    transition: "box-shadow 0.2s",
    "&:hover": {
      boxShadow: "0 18px 42px rgba(15,23,42,0.08)",
    },
  },
  cardPlain: {
    background: "transparent",
    boxShadow: "none",
  },
  cardProfile: {
    marginTop: "30px",
    textAlign: "center",
  },
  cardChart: {
    "& p": {
      marginTop: "0px",
      paddingTop: "0px",
    },
  },
};
export default cardStyle;
